export default __webpack_public_path__ + "static/media/certification-image.5be640fd.jpg";